module.exports = __webpack_public_path__ + "static/media/origami6.bebf500d.jpg";